import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { ROUTES } from "@constants";
import images from "@assets/images";
import "./Toolbar.css";

const TOOLBAR_ITEMS = [
  { id: "music", icon: images.iconMusic, label: "Âm thanh" },
  {
    id: "fullscreen",
    icon: images.iconFullscreen,
    label: "Toàn màn hình",
  },
  {
    id: "zoom-in",
    icon: images.iconPlus,
    label: "Phóng to",
  },
  {
    id: "zoom-out",
    icon: images.iconMinus,
    label: "Thu nhỏ",
  },
];

function Toolbar() {
  const location = useLocation();
  const audioRef = useRef(null);
  const [musicEnabled, setMusicEnabled] = useState(true);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;
    audio.volume = 0.45;
    audio.loop = true;
  }, []);

  // Chỉ hiển thị Toolbar ở Tổng quan (/), Mặt bằng (/mat-bang) và Tiện ích (/tien-ich)
  const allowedRoutes = [ROUTES.HOME, ROUTES.MAT_BANG, ROUTES.TIEN_ICH];
  if (!allowedRoutes.includes(location.pathname)) {
    return null;
  }

  const handleAction = (id) => {
    // if (id === 'zoom-in') {
    //   window.dispatchEvent(new CustomEvent('app-zoom-in'))
    // } else if (id === 'zoom-out') {
    //   window.dispatchEvent(new CustomEvent('app-zoom-out'))
    // } else
    if (id === "music") {
      const audio = audioRef.current;
      if (!audio) return;

      if (musicEnabled) {
        audio.pause();
        setMusicEnabled(false);
      } else {
        audio
          .play()
          .then(() => setMusicEnabled(true))
          .catch((err) => {
            console.warn("[Toolbar] Không thể phát nhạc:", err);
            setMusicEnabled(false);
          });
      }
      return;
    }

    if (id === "fullscreen") {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen().catch((err) => {
          console.error(
            `Error attempting to enable fullscreen: ${err.message}`,
          );
        });
      } else {
        document.exitFullscreen();
      }
    }
  };

  return (
    <aside className="toolbar" aria-label="Thanh công cụ">
      <audio
        ref={audioRef}
        src={`${import.meta.env.BASE_URL}musics/Soft Snowy Jazz Loop.wav`}
        autoPlay
      />
      <ul className="toolbar__list" role="list">
        {TOOLBAR_ITEMS.map(({ id, icon, label }) => (
          <li key={id} className="toolbar__item">
            <button
              id={`toolbar-btn-${id}`}
              className={`toolbar__btn${id === "music" && !musicEnabled ? " toolbar__btn--music-off" : ""}`}
              aria-label={label}
              title={label}
              onClick={() => handleAction(id)}
              type="button"
            >
              <span className="toolbar__label" aria-hidden="true">
                {label}
              </span>
              <img src={icon} alt={label} className="toolbar__icon" />
            </button>
          </li>
        ))}
      </ul>
    </aside>
  );
}

export default Toolbar;
